import axios from "axios"
import { toast } from "react-toastify";
import { ERROR, GET_ALL_OFFICERS, GET_ALL_SUBTASKS, GET_ALL_TASK_CATEGORIES, GET_ALL_TASK_PRIORITIES, GET_ALL_TASK_STATUSES, GET_ALL_TASK_TYPES, GET_ALL_TASKS, GET_DASHBOARD_SUMMARY, GET_RECENT_UPDATES, GET_SINGLE_TASK, LOADER } from "../actionType";

export const  getAllOfficers = (page, limit) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    const queryParams = new URLSearchParams({
        page,
        limit,
        is_active: true
    });

    try {
        dispatch({ type: LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/officer/get-branch-officer-report?${queryParams.toString()}`, { headers });

        if(response?.data?.data?.officers){

            console.log({resss: response?.data?.data?.officers});

            let officersList = response?.data?.data?.officers?.reduce((acc, item) => {
                acc.push(...(item?.officer_details || []));
                return acc;
            }, []) || [];
            
            console.log({ off: officersList}); 
            dispatch({ type: GET_ALL_OFFICERS, payload: officersList });
        }
    }
    catch (error) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching all officers", error);
    }
}

export const getAllTaskStatuses = (filters) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    const queryParams = new URLSearchParams();

    if(filters?.status_id){
        queryParams.append("status_id", filters.status_id);
    }
    if(filters?.status_name){
        queryParams.append("status_name", filters.status_name);
    }
    if(filters?.status_code){
        queryParams.append("status_code", filters.status_code);
    }
    if(filters?.is_active){
        queryParams.append("is_active", filters.is_active);
    }
    if(filters?.order_no){
        queryParams.append("order_no", filters.order_no);
    }

    try {
        dispatch({ type: LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/task/master/get-all-status?${queryParams.toString()}`, { headers });

        dispatch({ type: GET_ALL_TASK_STATUSES, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching all task statuses", error);
    }
}

export const getAllTaskPriorities = (filters) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    const queryParams = new URLSearchParams();

    if(filters?.priority_name){
        queryParams.append("priority_name", filters.priority_name);
    }
    if(filters?.priority_code){
        queryParams.append("priority_code", filters.priority_code);
    }
    if(filters?.is_active){
        queryParams.append("is_active", filters.is_active);
    }

    try {
        dispatch({ type: LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/task/master/get-all-priority?${queryParams.toString()}`, { headers });

        dispatch({ type: GET_ALL_TASK_PRIORITIES, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching all task priorities", error);
    }
}

export const getAllTaskCategories = (filters) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    const queryParams = new URLSearchParams();

    if(filters?.category_id){
        queryParams.append("category_id", filters.category_id);
    }
    if(filters?.category_name){
        queryParams.append("category_name", filters.category_name);
    }
    if(filters?.category_belongs_to){
        queryParams.append("category_belongs_to", filters.category_belongs_to);
    }
    if(filters?.is_active){
        queryParams.append("is_active", filters.is_active);
    }
    if(filters?.type_code){
        queryParams.append("type_code", filters.type_code);
    }
    if(filters?.category_type){
        queryParams.append("category_type", filters.category_type);
    }
    if(filters?.parent_category_name){
        queryParams.append("parent_category_name", filters.parent_category_name);
    }

    try {
        dispatch({ type: LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/task/master/get-all-category?${queryParams.toString()}`, { headers });

        dispatch({ type: GET_ALL_TASK_CATEGORIES, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching all task categories", error);
    }
}

export const getAllTaskTypes = (filters) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    const queryParams = new URLSearchParams();

    if(filters?.type_id){
        queryParams.append("type_id", filters.type_id);
    }
    if(filters?.type_name){
        queryParams.append("type_name", filters.type_name);
    }
    if(filters?.type_code){
        queryParams.append("type_code", filters.type_id);
    }
    if(filters?.is_active){
        queryParams.append("is_active", filters.is_active);
    }
    if(filters?.order_no){
        queryParams.append("order_no", filters.order_no);
    }

    try {
        dispatch({ type: LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/task/master/get-all-task-types?${queryParams.toString()}`, { headers });

        dispatch({ type: GET_ALL_TASK_TYPES, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching all task types", error);
    }
}

export const  getAllTasks = (page, limit, filters) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    const queryParams = new URLSearchParams({
        page,
        limit
    });

    if(filters?.task_id){
        queryParams.append("task_id", filters.task_id);
    }
    if(filters?.readable_task_id){
        queryParams.append("readable_task_id", filters.readable_task_id);
    }
    if(filters?.priority_id){
        queryParams.append("priority_id", filters.priority_id);
    }
    if(filters?.priority_code){
        queryParams.append("priority_code", filters.priority_code);
    }
    if(filters?.priority_name){
        queryParams.append("priority_name", filters.priority_name);
    }
    if(filters?.priority){
        queryParams.append("priority", filters.priority);
    }
    if(filters?.status_id){
        queryParams.append("status_id", filters.status_id);
    }
    if(filters?.status_code){
        queryParams.append("status_code", filters.status_code);
    }
    if(filters?.status_name){
        queryParams.append("status_name", filters.status_name);
    }
    if(filters?.status){
        queryParams.append("status", filters.status);
    }
    if(filters?.seeds_id){
        queryParams.append("seeds_id", filters.seeds_id);
    }
    if(filters?.emp_id){
        queryParams.append("emp_id", filters.emp_id);
    }
    if(filters?.global_search){
        queryParams.append("global_search", filters.global_search);
    }
    if(filters?.assigned_to){
        queryParams.append("assigned_to", filters.assigned_to);
    }
    if(filters?.created_by){
        queryParams.append("created_by", filters.created_by);
    }
    if(filters?.customer_mobile){
        queryParams.append("customer_mobile", filters.customer_mobile);
    }

    try {
        dispatch({ type: LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/task/get-all-tasks?${queryParams.toString()}`, { headers });

        dispatch({ type: GET_ALL_TASKS, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching all tasks", error);
    }
}

export const getDashboardSummary = (filters = null) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    const queryParams = new URLSearchParams();

    if(filters?.status_code){
        queryParams.append("status_code", filters.status_code);
    }
    if(filters?.priority_code){
        queryParams.append("priority_code", filters.priority_code);
    }
    if(filters?.updated_from){
        queryParams.append("updated_from", filters.updated_from);
    }
    if(filters?.updated_to){
        queryParams.append("updated_to", filters.updated_to);
    }

    try {
        dispatch({ type: LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/task/task-dashboard-summary?${queryParams.toString()}`, { headers });

        dispatch({ type: GET_DASHBOARD_SUMMARY, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching dashboard summary", error);
    }
}

export const  getSingleTask = (taskId) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    try {
        dispatch({ type: LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/task/get/${taskId}`, { headers });

        dispatch({ type: GET_SINGLE_TASK, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching single task info", error);
    }
}

export const getAllRecentUpdates = (page, limit, filters) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    const queryParams = new URLSearchParams({
        page,
        limit
    });

    if(filters?.customer_name){
        queryParams.append("customer_name", filters.customer_name);
    }
    if(filters?.readable_task_id){
        queryParams.append("readable_task_id", filters.readable_task_id);
    }
    if(filters?.category_id){
        queryParams.append("category_id", filters.category_id);
    }
    if(filters?.title){
        queryParams.append("title", filters.title);
    }
    if(filters?.global_search){
        queryParams.append("global_search", filters.global_search);
    }
    

    try {
        dispatch({ type: LOADER });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/task/recent-task-summary?${queryParams.toString()}`, { headers });

        dispatch({ type: GET_RECENT_UPDATES, payload: response?.data?.data });
    }
    catch (error) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching recent updates", error);
    }
}